import React from 'react';
import Image from 'next/image';
import deleteNext from '../../svgs/trash_delete_icon.svg';
import { NextImageProps } from '../NextImageProps';

export function DeleteNext({ className, width, height, alt }: NextImageProps) {
  return (
    <Image
      width={width}
      height={height}
      className={className}
      src={deleteNext}
      alt={alt ?? 'Slet'}
    />
  );
}
